import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { EntityTypeProvider as Provider } from '../../components/context/entity-type-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const ENTITY_TYPES_QUERY = graphql`
query NodeAllEntityTypesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "EntityTypes" } }) {
    nodes {
      data
    }
  }
}
`;

export const EntityTypesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(ENTITY_TYPES_QUERY), 'items')}>{children}</Provider>;
};
